import { useQuery } from '@tanstack/react-query'
import { fetchReapproCategoryPreview } from '../queries/reapproCategoryPreview.queries'

export const REAPPRO_CATEGORY_PREVIEW_KEY = 'reapproCategoryPreview'

export const useReapproCategoryPreview = (storeId: number, categoryId: number, enabled = true) =>
  useQuery({
    queryKey: [REAPPRO_CATEGORY_PREVIEW_KEY, storeId, categoryId],
    queryFn: () => fetchReapproCategoryPreview(storeId, categoryId),
    enabled,
    staleTime: 30_000,
  })
